document.addEventListener('DOMContentLoaded', function() {
  if (!window.syncFreeGiftWithCart || !window.customElements) return;

  function patchCartDrawer() {
    const CartDrawerClass = customElements.get('cart-drawer');
    if (!CartDrawerClass || !CartDrawerClass.prototype) return;

    const originalRenderContents = CartDrawerClass.prototype.renderContents;
    if (!originalRenderContents || CartDrawerClass.prototype.__freeGiftPatched) return;

    CartDrawerClass.prototype.__freeGiftPatched = true;

    CartDrawerClass.prototype.renderContents = function(parsedState) {
      // 1) Run the theme's original logic first
      originalRenderContents.call(this, parsedState);

      // 2) Then try to sync the free gift
      try {
        window.syncFreeGiftWithCart().then((newState) => {
          if (!newState || !newState.sections) return;

          this.productId = newState.id;

          this.getSectionsToRender().forEach((section) => {
            const sectionElement = section.selector
              ? document.querySelector(section.selector)
              : document.getElementById(section.id);

            if (sectionElement && newState.sections[section.id]) {
              sectionElement.innerHTML =
                this.getSectionInnerHTML(newState.sections[section.id], section.selector);
            }
          });
        }).catch((err) => {
          console && console.warn && console.warn('Free gift drawer sync error:', err);
        });
      } catch (e) {
        console && console.warn && console.warn('Free gift drawer sync error:', e);
      }
    };
  }

  if (customElements.get('cart-drawer')) {
    patchCartDrawer();
  } else if (customElements.whenDefined) {
    customElements.whenDefined('cart-drawer').then(patchCartDrawer);
  }
});
